/** A topic a person can ask to hear about; `groupBit` is its value in the mailing list's Topics group. */
export type WaitlistTopicId =
  "public_health" | "climate_environment" | "people_society" | "politics_world_affairs";

/** The topics offered on the waitlist, in display order. */
export const WAITLIST_TOPIC_IDS: readonly WaitlistTopicId[] = [
  "public_health",
  "climate_environment",
  "people_society",
  "politics_world_affairs",
];

const TOPIC_GROUP_BIT: Record<WaitlistTopicId, number> = {
  public_health: 1,
  climate_environment: 2,
  people_society: 4,
  politics_world_affairs: 8,
};

/** What a person fills in to join the waitlist. */
export interface WaitlistSignup {
  email: string;
  firstName: string;
  lastName: string;
  topics: readonly WaitlistTopicId[];
}

// The public sign-up endpoint of the waitlist's Mailchimp audience (an embed form's action).
const SUBSCRIBE_URL =
  "https://realitycheq.us20.list-manage.com/subscribe/post?u=e8ec6444e2d493f83555b0255&id=da463c424a&f_id=0007c2e1f0";
const TOPICS_GROUP_ID = 11;
const WAITLIST_TAG = "269";
// Mailchimp's bot trap: a field real people never fill in, which must be posted empty.
const HONEYPOT_FIELD = "b_e8ec6444e2d493f83555b0255_da463c424a";

/**
 * Adds a person to the waitlist. Mailchimp answers a cross-origin post with an opaque response,
 * so this resolves once the request was sent and rejects only when it could not be.
 */
export async function submitWaitlistSignup(signup: WaitlistSignup): Promise<void> {
  const body = new URLSearchParams({
    EMAIL: signup.email,
    FNAME: signup.firstName,
    LNAME: signup.lastName,
    tags: WAITLIST_TAG,
    [HONEYPOT_FIELD]: "",
  });
  for (const topic of signup.topics) {
    body.set(
      `group[${TOPICS_GROUP_ID}][${TOPIC_GROUP_BIT[topic]}]`,
      String(TOPIC_GROUP_BIT[topic])
    );
  }
  await fetch(SUBSCRIBE_URL, { method: "POST", mode: "no-cors", body });
}
